import UnderConstruction from "../UnderConstruction/UnderConstruction";
import styles from "./login.module.css";

const Login = () => {
    return (
        <UnderConstruction containerClassName={styles.loginContainer} />
    );
}

export default Login;
